<!-- SkyPlus Document Library - Fixed: No preview in properties, double-click opens viewer, horizontal buttons -->
<div class="sp-document-library-container" [class.properties-open]="showPropertiesPanel">
  <!-- Header -->
  <sp-header></sp-header>
  
  <!-- Sub Navigation -->
  <div class="sp-sub-nav">
    <div class="sp-sub-nav-tabs">
      <button *ngFor="let tab of subNavTabs" class="sp-sub-tab" [class.active]="tab.active" (click)="onTabClick(tab)">{{ tab.label }}</button>
    </div>
    <div class="sp-sub-nav-actions"><span class="sp-more-menu">More <span class="material-icons">expand_more</span></span></div>
  </div>
  
  <!-- Main Content Area -->
  <div class="sp-main-content">
    <!-- Sidebar (Folder Tree) -->
    <aside class="sp-sidebar" *ngIf="showSidebar && viewType === 'library'">
      <div class="sp-sidebar-header"><span class="material-icons">folder</span><span>Folders</span></div>
      <div class="sp-folder-tree">
        <ng-container *ngFor="let folder of folderTree">
          <ng-container *ngTemplateOutlet="folderItem; context: { folder: folder }"></ng-container>
        </ng-container>
      </div>
    </aside>
    
    <!-- Document List Area -->
    <main class="sp-content-area" [class.no-sidebar]="!showSidebar || viewType !== 'library'">
      
      <!-- Toolbar - HORIZONTAL BUTTONS with Delete -->
      <div class="sp-toolbar">
        <div class="sp-toolbar-left">
          <button class="sp-btn sp-btn-primary" (click)="uploadDocuments()" *ngIf="viewType === 'library' && canUpload()">
            <span class="material-icons">note_add</span>New Document<span class="material-icons">expand_more</span>
          </button>
           <button class="sp-btn sp-btn-primary" (click)="openIndexingQueue()" *ngIf="viewType === 'library' && canUpload()">
            <span class="material-icons">upload_file</span>Upload & Index
          </button>
          <button class="sp-btn sp-btn-secondary" (click)="createNewFolder()" *ngIf="viewType === 'library' && canUpload()">
            <span class="material-icons">create_new_folder</span>New Folder
          </button>
          <!-- Delete Button - Shows when documents are selected -->
          <button class="sp-btn sp-btn-danger" 
                  (click)="deleteSelectedDocuments()" 
                  *ngIf="hasSelectedDocuments() && canDeleteInFolder()"
                  [disabled]="isDeleting">
            <span class="material-icons" *ngIf="!isDeleting">delete</span>
            <span class="material-icons spinning" *ngIf="isDeleting">autorenew</span>
            <span *ngIf="!isDeleting">Delete ({{ getSelectedDocuments().length }})</span>
            <span *ngIf="isDeleting">Deleting...</span>
          </button>
        </div>
        
        <div class="sp-toolbar-right">
          <div class="sp-view-toggle">
            <!-- ADVANCED SEARCH BUTTON - ADD THIS -->
          <button class="sp-btn sp-btn-advanced-search" 
                  (click)="toggleAdvancedSearch()" 
                  [class.active]="showAdvancedSearch"
                  title="Advanced Search">
            <span class="material-icons">tune</span>
            <span class="btn-label">Advanced</span>
          </button>
          </div>
        </div>
      </div>

      <!-- Advanced Search Panel (slides down from header) -->
      <div class="sp-advanced-search-panel" *ngIf="showAdvancedSearch">
        <div class="sp-advanced-search-container">
          
          <!-- Left: Document Type Selector (Collapsible) -->
          <div class="sp-search-left">
            <div class="sp-doctype-selector">
              <button class="sp-doctype-dropdown-btn" (click)="toggleDocTypeDropdown()">
                <span class="material-icons" *ngIf="!selectedSearchDocType">folder_open</span>
                <span class="material-icons" *ngIf="selectedSearchDocType" [style.color]="selectedSearchDocType.color">{{ selectedSearchDocType.icon }}</span>
                <span class="sp-doctype-label">{{ selectedSearchDocType ? selectedSearchDocType.name : 'All Document Types' }}</span>
                <span class="material-icons dropdown-arrow">{{ showDocTypeDropdown ? 'expand_less' : 'expand_more' }}</span>
              </button>
              
              <!-- Dropdown List -->
              <div class="sp-doctype-dropdown" *ngIf="showDocTypeDropdown">
                <div class="sp-doctype-option" 
                     [class.selected]="selectedSearchDocType === null"
                     (click)="selectSearchDocType(null); showDocTypeDropdown = false;">
                  <span class="material-icons">folder_open</span>
                  <span>All Document Types</span>
                </div>
                <div class="sp-doctype-option" 
                     *ngFor="let docType of searchDocumentTypes"
                     [class.selected]="selectedSearchDocType?.id === docType.id"
                     (click)="selectSearchDocType(docType); showDocTypeDropdown = false;">
                  <span class="material-icons" [style.color]="docType.color">{{ docType.icon }}</span>
                  <span>{{ docType.name }}</span>
                </div>
              </div>
            </div>
            
            <!-- Date Range -->
            <div class="sp-search-date-section">
              <div class="sp-search-field-inline">
                <label>From</label>
                <input type="date" [(ngModel)]="searchDateFrom">
              </div>
              <div class="sp-search-field-inline">
                <label>To</label>
                <input type="date" [(ngModel)]="searchDateTo">
              </div>
            </div>
          </div>
          
          <!-- Right: Dynamic Fields Grid -->
          <div class="sp-search-right">
            <div class="sp-search-fields-grid" *ngIf="selectedSearchDocType">
              <div class="sp-search-field-item" *ngFor="let field of searchableSearchFields()">
                <label>{{ field.label }}</label>
                
                <input *ngIf="field.type === 'text'"
                       type="text"
                       [(ngModel)]="searchFieldValues[field.propertyName]"
                       [placeholder]="'Enter ' + field.label"
                       [attr.list]="'dladv_' + field.propertyName"
                       (focus)="onFieldSuggest(field, selectedSearchDocType?.id, null)"
                       (input)="onFieldSuggest(field, selectedSearchDocType?.id, null)"
                       autocomplete="off">
                <datalist *ngIf="field.type === 'text'" [id]="'dladv_' + field.propertyName">
                  <option *ngFor="let v of fieldSuggestions[field.propertyName] || []" [value]="v"></option>
                </datalist>

                <input *ngIf="field.type === 'number'"
                       type="number"
                       [(ngModel)]="searchFieldValues[field.propertyName]"
                       [placeholder]="'Enter ' + field.label">
                
                <input *ngIf="field.type === 'date'"
                       type="date"
                       [(ngModel)]="searchFieldValues[field.propertyName]">
                
                <select *ngIf="field.type === 'select'"
                        [(ngModel)]="searchFieldValues[field.propertyName]">
                  <option value="">-- Select --</option>
                  <option *ngFor="let opt of field.options" [value]="opt.value">{{ opt.label }}</option>
                </select>
              </div>
            </div>
            
            <!-- No Document Type Selected Message -->
            <div class="sp-search-hint" *ngIf="!selectedSearchDocType">
              <span class="material-icons">info</span>
              <span>Select a document type to search by specific fields, or search all documents by date range.</span>
            </div>
          </div>
          
          <!-- Actions -->
          <div class="sp-search-actions-bar">
            <button class="sp-btn sp-btn-secondary" (click)="clearAdvancedSearch()">
              <span class="material-icons">clear</span> Clear
            </button>
            <button class="sp-btn sp-btn-primary" (click)="executeAdvancedSearch()" [disabled]="isSearching">
              <span class="material-icons" *ngIf="!isSearching">search</span>
              <span class="material-icons spinning" *ngIf="isSearching">autorenew</span>
              {{ isSearching ? 'Searching...' : 'Search' }}
            </button>
          </div>
          
        </div>
      </div>

      <!-- Search banner — a single slim row. Results render inline in the same
           document table below (one unified view, no stacked panels). -->
      <div class="sp-search-banner" *ngIf="hasSearchResults"
           style="display:flex;align-items:center;gap:10px;margin:6px 12px;padding:8px 12px;border:1px solid #bfdbfe;background:#eff6ff;border-radius:8px;font-size:13px;color:#1e40af;">
        <span class="material-icons" style="font-size:18px;">{{ searchError ? 'error_outline' : 'fact_check' }}</span>
        <span *ngIf="!searchError">
          <strong>{{ totalSearchResults }}</strong> result(s)
          <span *ngIf="contextScopeFolderId">in this folder</span>
          <span *ngIf="!contextScopeFolderId">across all folders</span>
          <span *ngIf="searchEngineUsed" style="color:#64748b;">· {{ searchEngineUsed | uppercase }}</span>
        </span>
        <span *ngIf="searchError" style="color:#b91c1c;">{{ searchError }}</span>
        <span style="flex:1;"></span>
        <button (click)="closeSearchResults()"
                style="display:inline-flex;align-items:center;gap:5px;font-size:12.5px;padding:5px 11px;border:1px solid #93c5fd;background:#fff;color:#1e40af;border-radius:6px;cursor:pointer;">
          <span class="material-icons" style="font-size:16px;">close</span> Clear search
        </button>
      </div>

      <!-- Command bar — single slim row: navigation + breadcrumb path (or
           view title) + file-name search + refresh. Replaces the old tall
           Page Title Bar so the document list owns the vertical space. -->
      <div class="sp-breadcrumbs">
        <ng-container *ngIf="viewType === 'library'">
          <button class="sp-nav-btn" (click)="goBack()" [disabled]="breadcrumbs.length <= 1"><span class="material-icons">arrow_back</span></button>
          <button class="sp-nav-btn" (click)="goUp()" [disabled]="breadcrumbs.length <= 1"><span class="material-icons">arrow_upward</span></button>
          <div class="sp-breadcrumb-path">
            <span class="material-icons folder-icon">folder</span>
            <ng-container *ngFor="let crumb of breadcrumbs; let last = last">
              <span class="sp-crumb" [class.active]="last" (click)="navigateToBreadcrumb(crumb)">{{ crumb.name }}</span>
              <span class="sp-crumb-sep" *ngIf="!last">/</span>
            </ng-container>
          </div>
        </ng-container>
        <ng-container *ngIf="viewType !== 'library'">
          <button class="sp-nav-btn" (click)="goBack()"><span class="material-icons">arrow_back</span></button>
          <div class="sp-breadcrumb-path">
            <span class="material-icons folder-icon" *ngIf="viewType === 'recent'">history</span>
            <span class="material-icons folder-icon" *ngIf="viewType === 'favorites'">star</span>
            <span class="sp-crumb active">{{ pageTitle }}</span>
          </div>
        </ng-container>
        <div class="sp-bar-spacer"></div>
        <div class="sp-search-box">
          <span class="material-icons search-icon">search</span>
          <input type="text"
                 placeholder="Search by file name..."
                 [(ngModel)]="searchTerm"
                 (keyup.enter)="executeSimpleSearch()">
          <button class="sp-search-btn" (click)="executeSimpleSearch()" [disabled]="isSearching || !searchTerm" title="Search">
            <span class="material-icons" *ngIf="!isSearching">arrow_forward</span>
            <span class="material-icons spinning" *ngIf="isSearching">autorenew</span>
          </button>
          <button class="sp-search-clear" *ngIf="searchTerm && !isSearching" (click)="clearSimpleSearch()" title="Clear">
            <span class="material-icons">close</span>
          </button>
        </div>
        <button class="sp-nav-btn" (click)="refreshFolder()" title="Refresh"><span class="material-icons">refresh</span></button>
      </div>

      <!-- Folder-aware contextual search: collapsed to a slim chip by
           default so the list keeps the space; expands on click. -->
      <div *ngIf="contextDocType && viewType === 'library' && !hasSearchResults && !contextSearchOpen"
           class="sp-context-chip" (click)="contextSearchOpen = true">
        <span class="material-icons" [style.color]="contextDocType.color || '#2563eb'">{{ contextDocType.icon || 'search' }}</span>
        <span>Search in this folder — <strong>{{ contextDocType.name }}</strong></span>
        <span class="material-icons">expand_more</span>
      </div>
      <div *ngIf="contextDocType && viewType === 'library' && !hasSearchResults && contextSearchOpen"
           style="margin:6px 12px;border:1px solid #bfdbfe;background:#eff6ff;border-radius:8px;padding:10px 14px;">
        <div style="display:flex;align-items:center;gap:8px;margin-bottom:8px;font-size:13px;color:#1e40af;cursor:pointer;"
             (click)="contextSearchOpen = false">
          <span class="material-icons" style="font-size:18px;" [style.color]="contextDocType.color || '#2563eb'">{{ contextDocType.icon || 'search' }}</span>
          <span>Search in this folder — <strong>{{ contextDocType.name }}</strong></span>
          <span class="material-icons" style="font-size:18px;margin-left:auto;">expand_less</span>
        </div>
        <div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));gap:10px;">
          <div>
            <label style="display:block;font-size:11px;color:#475569;margin-bottom:3px;">File / folder name</label>
            <input type="text" [(ngModel)]="contextNameValue" placeholder="name contains…"
                   style="width:100%;height:32px;font-size:13px;padding:0 9px;border:1px solid #cbd5e1;border-radius:5px;" />
          </div>
          <div *ngFor="let field of contextSearchableFields()">
            <label style="display:block;font-size:11px;color:#475569;margin-bottom:3px;">{{ field.label }}</label>
            <select *ngIf="field.type === 'select'" [(ngModel)]="contextSearchValues[field.propertyName]"
                    style="width:100%;height:32px;font-size:13px;padding:0 8px;border:1px solid #cbd5e1;border-radius:5px;">
              <option value="">— any —</option>
              <option *ngFor="let opt of field.options" [value]="opt.value">{{ opt.label }}</option>
            </select>
            <input *ngIf="field.type !== 'select'" [type]="field.type === 'date' ? 'date' : 'text'"
                   [(ngModel)]="contextSearchValues[field.propertyName]" [placeholder]="'Enter ' + field.label"
                   [attr.list]="field.type === 'text' ? 'dlctx_' + field.propertyName : null"
                   (focus)="onFieldSuggest(field, contextDocType?.id, currentFolderId)"
                   (input)="onFieldSuggest(field, contextDocType?.id, currentFolderId)"
                   autocomplete="off"
                   style="width:100%;height:32px;font-size:13px;padding:0 9px;border:1px solid #cbd5e1;border-radius:5px;" />
            <datalist *ngIf="field.type === 'text'" [id]="'dlctx_' + field.propertyName">
              <option *ngFor="let v of fieldSuggestions[field.propertyName] || []" [value]="v"></option>
            </datalist>
          </div>
        </div>
        <div style="display:flex;justify-content:flex-end;gap:8px;margin-top:11px;">
          <button (click)="clearContextSearch()"
                  style="font-size:13px;padding:6px 12px;border:1px solid #cbd5e1;background:#fff;border-radius:5px;cursor:pointer;">Clear</button>
          <button (click)="executeContextSearch()"
                  style="font-size:13px;padding:6px 14px;border:1px solid #2563eb;background:#2563eb;color:#fff;border-radius:5px;cursor:pointer;display:inline-flex;align-items:center;gap:5px;">
            <span class="material-icons" style="font-size:16px;">search</span> Search
          </button>
        </div>
      </div>
      
      <!-- Upload Progress -->
      <div class="sp-upload-progress" *ngIf="isUploading">
        <div class="sp-progress-bar"><div class="sp-progress-fill" [style.width.%]="uploadProgress"></div></div>
        <span class="sp-progress-text">Uploading... {{ uploadProgress }}%</span>
      </div>
      
      <!-- Document Table - SINGLE CLICK for properties, DOUBLE CLICK for viewer -->
      <div class="sp-document-table">
        <div class="sp-table-header" [style.gridTemplateColumns]="gridTemplate" [class.sp-resizing]="isColResizing">
          <div class="sp-col sp-col-checkbox"><input type="checkbox" [checked]="selectAll" (change)="toggleSelectAll()"></div>
          <div class="sp-col sp-col-name">NAME
            <span class="sp-col-resizer" (mousedown)="startColResize($event, 'name')" title="Drag to resize column"></span>
          </div>
          <div class="sp-col" *ngFor="let col of extraColumns()">{{ col.label | uppercase }}
            <span class="sp-col-resizer" (mousedown)="startColResize($event, col.key)" title="Drag to resize column"></span>
          </div>
        </div>
        
        <div class="sp-table-body">
          <div class="sp-loading-state" *ngIf="isLoading"><span class="material-icons spinning">autorenew</span><p>Loading documents...</p></div>
          
          <div class="sp-empty-state" *ngIf="!isLoading && displayedDocuments.length === 0">
            <!-- Search mode: make "no matches" unambiguous (not "broken"). -->
            <ng-container *ngIf="hasSearchResults">
              <span class="material-icons">{{ searchError ? 'error_outline' : 'search_off' }}</span>
              <h3 *ngIf="!searchError">No documents match your search</h3>
              <h3 *ngIf="searchError">Search couldn’t complete</h3>
              <p *ngIf="!searchError">
                Nothing matches these values{{ contextScopeFolderId ? ' in this folder' : '' }}.
                Try fewer or different values (tip: pick from the suggestions), or
                <a (click)="closeSearchResults()" style="color:#2563eb;cursor:pointer;">clear the search</a>.
              </p>
              <p *ngIf="searchError">{{ searchError }} — <a (click)="closeSearchResults()" style="color:#2563eb;cursor:pointer;">clear the search</a> and try again.</p>
            </ng-container>
            <!-- Normal folder / view empty states. -->
            <ng-container *ngIf="!hasSearchResults">
              <span class="material-icons" *ngIf="viewType === 'recent'">history</span>
              <span class="material-icons" *ngIf="viewType === 'favorites'">star_border</span>
              <span class="material-icons" *ngIf="viewType === 'library'">folder_open</span>
              <h3 *ngIf="viewType === 'recent'">No recent documents</h3>
              <h3 *ngIf="viewType === 'favorites'">No favourites yet</h3>
              <h3 *ngIf="viewType === 'library'">This folder is empty</h3>
              <p *ngIf="viewType === 'recent'">Documents you modify will appear here</p>
              <p *ngIf="viewType === 'favorites'">Star documents to add them to your favourites</p>
              <p *ngIf="viewType === 'library'">Upload documents or create folders to get started</p>
            </ng-container>
          </div>
          
          <!-- SINGLE CLICK = properties, DOUBLE CLICK = open viewer (or, in
               search mode, open the result / navigate to its folder). -->
          <div class="sp-table-row" *ngFor="let doc of displayedDocuments"
               [style.gridTemplateColumns]="gridTemplate"
               [class.selected]="doc.isSelected"
               [class.active]="selectedDocument?.id === doc.id"
               (click)="onItemClick(doc, $event)"
               (dblclick)="hasSearchResults ? openSearchResult(doc) : onItemDoubleClick(doc, $event)">
            <div class="sp-col sp-col-checkbox" (click)="$event.stopPropagation()"><input type="checkbox" [checked]="doc.isSelected" (change)="toggleItemSelection(doc, $event)"></div>
            <div class="sp-col sp-col-name">
              <span class="material-icons doc-icon" [style.color]="doc.iconColor">{{ doc.icon }}</span>
              <span class="doc-name">{{ doc.name }}</span>
              <!-- Search mode: show which folder this hit lives in. -->
              <span class="sp-row-location" *ngIf="hasSearchResults && doc.folderName"
                    (click)="navigateToDocumentFolder(doc, $event)"
                    title="Open containing folder: {{ doc.folderName }}"
                    style="margin-left:8px;font-size:11px;color:#2563eb;cursor:pointer;display:inline-flex;align-items:center;gap:3px;vertical-align:middle;">
                <span class="material-icons" style="font-size:13px;">folder_open</span>{{ doc.folderName }}
              </span>
            </div>
            <div class="sp-col" *ngFor="let col of extraColumns()">
              <span class="sp-status-badge" *ngIf="col.key === 'status'">{{ doc.status || 'Active' }}</span>
              <ng-container *ngIf="col.key !== 'status'">{{ cellText(doc, col) }}</ng-container>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Pagination (folder listing only — search shows its count in the banner) -->
      <div class="sp-pagination" *ngIf="totalItems > 0 && !hasSearchResults">
        <span class="sp-page-info">Showing {{ startItem }}-{{ endItem }} of {{ totalItems }}</span>
        <div class="sp-page-controls">
          <button class="sp-page-btn" [disabled]="currentPage === 1" (click)="onPageChange(currentPage - 1)"><span class="material-icons">chevron_left</span>Prev</button>
          <span class="sp-page-number">{{ currentPage }}</span>
          <button class="sp-page-btn" [disabled]="currentPage >= totalPages" (click)="onPageChange(currentPage + 1)">Next<span class="material-icons">chevron_right</span></button>
        </div>
        <div class="sp-page-size"><span>Items per page:</span><select [(ngModel)]="pageSize" (change)="onPageSizeChange(pageSize)"><option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option></select></div>
      </div>
    </main>
    
    <!-- Properties Panel (With Tabs: General, Custom, Versions, Permissions) -->
<aside class="sp-properties-panel" *ngIf="showPropertiesPanel && selectedDocument">
  
  <!-- Header -->
  <div class="sp-properties-header">
    <div class="sp-properties-title">
      <span class="material-icons" [style.color]="selectedDocument.iconColor">{{ selectedDocument.icon }}</span>
      <span class="sp-doc-name">{{ selectedDocument.name }}</span>
    </div>
    <button class="sp-close-btn" (click)="closePropertiesPanel()">
      <span class="material-icons">close</span>
    </button>
  </div>
  
  <!-- Action list (labeled, Alfresco Share style) -->
  <div class="sp-action-list">
    <button class="sp-action-row" (click)="downloadDocument()">
      <span class="material-icons">download</span><span>Download</span>
    </button>
    <button class="sp-action-row" (click)="openInNewTab()">
      <span class="material-icons">open_in_new</span><span>View in browser</span>
    </button>
    <button class="sp-action-row" (click)="signDocument()">
      <span class="material-icons">draw</span><span>Sign document</span>
    </button>
    <button class="sp-action-row" *spHasFeature="'flipViewer'" (click)="openSelectedInFlipViewer()">
      <span class="material-icons">menu_book</span><span>Reader view</span>
    </button>
    <button class="sp-action-row" *ngIf="canEditDoc()" (click)="indexDocument()">
      <span class="material-icons">sell</span><span>Index / re-index</span>
    </button>
    <button class="sp-action-row" *ngIf="canEditDoc()" (click)="openMove()">
      <span class="material-icons">drive_file_move</span><span>Move to&hellip;</span>
    </button>
    <button class="sp-action-row" *ngIf="canEditDoc() && !selectedDocLocked" (click)="checkOut()">
      <span class="material-icons">lock</span><span>Check out</span>
    </button>
    <button class="sp-action-row" *ngIf="canEditDoc() && selectedDocLocked" (click)="checkIn()">
      <span class="material-icons">lock_open</span><span>Check in</span>
    </button>
    <button class="sp-action-row danger" *ngIf="canDeleteDoc()" (click)="deleteDocument()">
      <span class="material-icons">delete</span><span>Delete document</span>
    </button>
  </div>
  
  <!-- Properties Tabs -->
  <div class="sp-properties-tabs">
    <button class="sp-prop-tab" 
            [class.active]="activePropertiesTab === 'general'" 
            (click)="setPropertiesTab('general')">
      General
    </button>
    <button class="sp-prop-tab" 
            [class.active]="activePropertiesTab === 'custom'" 
            (click)="setPropertiesTab('custom')"
            *ngIf="customMetadataFields.length > 0">
      Custom <span class="tab-badge">{{ customMetadataFields.length }}</span>
    </button>
    <button class="sp-prop-tab" 
            [class.active]="activePropertiesTab === 'versions'" 
            (click)="setPropertiesTab('versions')">
      Versions
    </button>
    <!-- <button class="sp-prop-tab" 
            [class.active]="activePropertiesTab === 'permissions'" 
            (click)="setPropertiesTab('permissions')">
      Permissions
    </button> -->
  </div>
  
  <!-- Properties Content (Scrollable) -->
  <div class="sp-properties-content">
    
    <!-- Loading State -->
    <div class="sp-loading-properties" *ngIf="isLoadingProperties">
      <span class="material-icons spinning">autorenew</span>
      <p>Loading properties...</p>
    </div>
    
    <!-- ==================== GENERAL TAB ==================== -->
    <div class="sp-tab-content" *ngIf="!isLoadingProperties && activePropertiesTab === 'general'">
      
      <!-- View Mode -->
      <ng-container *ngIf="!isEditingGeneral">
        
        <!-- Editable Properties Section -->
        <div class="sp-properties-section">
          <div class="sp-section-header">
            <h4 class="sp-section-title sp-collapse-head" (click)="toggleSection('props')">
              <span class="material-icons sp-chevron">{{ isCollapsed('props') ? 'chevron_right' : 'expand_more' }}</span>
              Document Properties
            </h4>
            <button class="sp-edit-btn-small" (click)="enterGeneralEditMode()" title="Edit">
              <span class="material-icons">edit</span>
            </button>
          </div>
          <ng-container *ngIf="!isCollapsed('props')">
          
          <div class="sp-property-item">
            <span class="sp-prop-icon material-icons">description</span>
            <div class="sp-prop-content">
              <span class="sp-prop-label">Name</span>
              <span class="sp-prop-value">{{ selectedDocument.name }}</span>
            </div>
          </div>
          
          <div class="sp-property-item">
            <span class="sp-prop-icon material-icons">title</span>
            <div class="sp-prop-content">
              <span class="sp-prop-label">Title</span>
              <span class="sp-prop-value">{{ generalProperties.title || '-' }}</span>
            </div>
          </div>
          
          <div class="sp-property-item">
            <span class="sp-prop-icon material-icons">notes</span>
            <div class="sp-prop-content">
              <span class="sp-prop-label">Description</span>
              <span class="sp-prop-value">{{ generalProperties.description || '-' }}</span>
            </div>
          </div>
          </ng-container>
        </div>
        
        <!-- Read-only Info Section -->
        <div class="sp-properties-section sp-readonly">
          <h4 class="sp-section-title sp-collapse-head" (click)="toggleSection('info')">
            <span class="material-icons sp-chevron">{{ isCollapsed('info') ? 'chevron_right' : 'expand_more' }}</span>
            Document Info
          </h4>
          <ng-container *ngIf="!isCollapsed('info')">
          <div class="sp-property-item" *ngFor="let prop of readOnlyProperties">
            <span class="sp-prop-icon material-icons">{{ prop.icon }}</span>
            <div class="sp-prop-content">
              <span class="sp-prop-label">{{ prop.label }}</span>
              <span class="sp-prop-value">{{ prop.value }}</span>
            </div>
          </div>
          </ng-container>
        </div>
        
      </ng-container>
      
      <!-- Edit Mode for General Properties -->
      <ng-container *ngIf="isEditingGeneral">
        
        <div class="sp-edit-form-section">
          <h4 class="sp-section-title">Edit Document Properties</h4>
          
          <div class="sp-form-field">
            <label class="sp-field-label">Name</label>
            <input type="text" 
                   class="sp-field-input"
                   [(ngModel)]="editableGeneralProperties.name"
                   placeholder="Document name">
          </div>
          
          <div class="sp-form-field">
            <label class="sp-field-label">Title</label>
            <input type="text" 
                   class="sp-field-input"
                   [(ngModel)]="editableGeneralProperties.title"
                   placeholder="Enter title">
          </div>
          
          <div class="sp-form-field">
            <label class="sp-field-label">Description</label>
            <textarea class="sp-field-input sp-textarea"
                      [(ngModel)]="editableGeneralProperties.description"
                      placeholder="Enter description"
                      rows="3"></textarea>
          </div>
        </div>
        
        <div class="sp-edit-actions">
          <button class="sp-btn sp-btn-cancel" (click)="cancelGeneralEdit()" [disabled]="isSavingProperties">
            Cancel
          </button>
          <button class="sp-btn sp-btn-save" (click)="saveGeneralProperties()" [disabled]="isSavingProperties">
            <span class="material-icons spinning" *ngIf="isSavingProperties">autorenew</span>
            <span *ngIf="!isSavingProperties">Save</span>
            <span *ngIf="isSavingProperties">Saving...</span>
          </button>
        </div>
        
      </ng-container>
      
    </div>
    
    <!-- ==================== CUSTOM METADATA TAB ==================== -->
    <div class="sp-tab-content" *ngIf="!isLoadingProperties && activePropertiesTab === 'custom'">
      
      <!-- View Mode -->
      <ng-container *ngIf="!isEditingCustom">
        
        <div class="sp-properties-section">
          <div class="sp-section-header">
            <h4 class="sp-section-title">Custom Metadata</h4>
            <button class="sp-edit-btn-small" (click)="enterCustomEditMode()" title="Edit">
              <span class="material-icons">edit</span>
            </button>
          </div>
          
          <div class="sp-property-item" *ngFor="let field of customMetadataFields">
            <span class="sp-prop-icon material-icons">label</span>
            <div class="sp-prop-content">
              <span class="sp-prop-label">{{ field.label }}</span>
              <span class="sp-prop-value">{{ field.value || '-' }}</span>
            </div>
          </div>
          
          <div class="sp-empty-custom" *ngIf="customMetadataFields.length === 0">
            <span class="material-icons">info</span>
            <p>No custom metadata available</p>
          </div>
        </div>
        
      </ng-container>
      
      <!-- Edit Mode for Custom Properties -->
      <ng-container *ngIf="isEditingCustom">
        
        <div class="sp-edit-form-section">
          <h4 class="sp-section-title">Edit Custom Metadata</h4>
          
          <div class="sp-form-field" *ngFor="let field of customMetadataFields">
            <label class="sp-field-label">{{ field.label }}</label>
            
            <!-- Text Input -->
            <input *ngIf="field.type === 'text'"
                   type="text" 
                   class="sp-field-input"
                   [(ngModel)]="editableCustomProperties[field.propertyName]"
                   [placeholder]="'Enter ' + field.label">
            
            <!-- Number Input -->
            <input *ngIf="field.type === 'number'"
                   type="number" 
                   class="sp-field-input"
                   [(ngModel)]="editableCustomProperties[field.propertyName]"
                   [placeholder]="'Enter ' + field.label">
            
            <!-- Date Input -->
            <input *ngIf="field.type === 'date'"
                   type="date" 
                   class="sp-field-input"
                   [(ngModel)]="editableCustomProperties[field.propertyName]">
            
            <!-- Boolean (Checkbox) -->
            <label *ngIf="field.type === 'boolean'" class="sp-checkbox-label">
              <input type="checkbox"
                     [(ngModel)]="editableCustomProperties[field.propertyName]">
              <span>{{ field.label }}</span>
            </label>
          </div>
        </div>
        
        <div class="sp-edit-actions">
          <button class="sp-btn sp-btn-cancel" (click)="cancelCustomEdit()" [disabled]="isSavingProperties">
            Cancel
          </button>
          <button class="sp-btn sp-btn-save" (click)="saveCustomProperties()" [disabled]="isSavingProperties">
            <span class="material-icons spinning" *ngIf="isSavingProperties">autorenew</span>
            <span *ngIf="!isSavingProperties">Save</span>
            <span *ngIf="isSavingProperties">Saving...</span>
          </button>
        </div>
        
      </ng-container>
      
    </div>
    
    <!-- ==================== VERSIONS TAB ==================== -->
    <div class="sp-tab-content" *ngIf="!isLoadingProperties && activePropertiesTab === 'versions'">
      <div class="sp-versions-list">
        <div class="sp-version-item">
          <span class="sp-version-number">v{{ selectedDocument.version || '1.0' }}</span>
          <span class="sp-version-date">{{ formatDate(selectedDocument.modifiedAt) }}</span>
          <span class="sp-version-user">{{ selectedDocument.modifiedBy }}</span>
          <span class="sp-version-badge current">Current</span>
        </div>
      </div>
    </div>
    
    <!-- ==================== PERMISSIONS TAB ==================== -->
    <!-- <div class="sp-tab-content" *ngIf="!isLoadingProperties && activePropertiesTab === 'permissions'">
      <div class="sp-permissions-info">
        <p class="sp-perm-note">
          <span class="material-icons">info</span>
          Permissions are managed through Alfresco Share
        </p>
      </div>
    </div> -->
    
  </div>
  
</aside>
</div>

  
</div>

<ng-template #folderItem let-folder="folder">
  <div class="sp-folder-node" [style.padding-left.px]="folder.level * 16 + 8" [class.selected]="isFolderSelected(folder.id)">
    <button class="sp-expand-btn" *ngIf="folder.hasChildren" (click)="toggleFolderExpand(folder, $event)">
      <span class="material-icons" *ngIf="!folder.isLoading">{{ folder.isExpanded ? 'expand_more' : 'chevron_right' }}</span>
      <span class="material-icons spinning" *ngIf="folder.isLoading">autorenew</span>
    </button>
    <span class="sp-expand-placeholder" *ngIf="!folder.hasChildren"></span>
    <span class="material-icons folder-icon">folder</span>
    <span class="folder-name" (click)="navigateToFolder(folder.id)">{{ folder.name }}</span>
  </div>
  <ng-container *ngIf="folder.isExpanded">
    <ng-container *ngFor="let child of folder.children">
      <ng-container *ngTemplateOutlet="folderItem; context: { folder: child }"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<!-- ===== EMBEDDED DOCUMENT VIEWER (DigiWorks Style) ===== -->
<!-- ===== EMBEDDED DOCUMENT VIEWER (Iframe Fallback) ===== -->
<div class="viewer-wrapper" *ngIf="showViewer && viewerContentUrl">
  
  <!-- Viewer Header Bar -->
  <div class="viewer-header-bar">
    <div class="viewer-header-left">
      <button class="back-btn" (click)="closeViewer()" title="Back to Documents">
        <span class="material-icons">arrow_back</span>
      </button>
      <span class="viewer-filename">{{ viewerFileName }}</span>
      <span class="viewer-version" *ngIf="viewerFileVersion">{{ viewerFileVersion }}</span>
    </div>
    <div class="viewer-header-right">
      <button class="action-btn"
          *spHasFeature="'flipViewer'"
          (click)="openInFlipViewer()"
          title="Open in reader view">
        <span class="material-icons">menu_book</span>
      </button>
      <button class="action-btn" (click)="downloadDocument()" title="Download">
        <span class="material-icons">download</span>
      </button>
      <button class="action-btn" (click)="signDocument()" title="Sign Document">
        <span class="material-icons">draw</span>
      </button>
    </div>
  </div>
  
  <!-- Viewer Content - Using iframe -->
  <div class="viewer-body">
    <iframe 
      [src]="viewerContentUrl | safe:'resourceUrl'"
      class="viewer-iframe"
      frameborder="0">
    </iframe>
  </div>
  
</div>
<!-- New Folder modal (Round 6.2) — Name + Title mandatory, Description optional -->
<div class="sp-newfolder-overlay" *ngIf="newFolderOpen"
     style="position:fixed;inset:0;background:rgba(15,23,42,.45);display:flex;align-items:center;justify-content:center;z-index:1000;">
  <div style="background:#fff;border-radius:10px;width:480px;max-width:92vw;display:flex;flex-direction:column;box-shadow:0 10px 40px rgba(0,0,0,.25);">
    <div style="display:flex;align-items:center;justify-content:space-between;padding:14px 16px;border-bottom:1px solid #e5e7eb;">
      <span style="font-size:15px;font-weight:600;color:#1f2937;display:flex;align-items:center;gap:8px;">
        <span class="material-icons" style="font-size:20px;color:#f59e0b;">create_new_folder</span>
        New Folder
      </span>
      <button (click)="cancelNewFolder()" [disabled]="newFolderBusy"
              style="border:none;background:none;cursor:pointer;font-size:18px;color:#6b7280;">&times;</button>
    </div>

    <div style="padding:16px;display:flex;flex-direction:column;gap:12px;">
      <label style="display:flex;flex-direction:column;gap:5px;font-size:12.5px;color:#374151;font-weight:500;">
        Folder name <span style="color:#dc2626;">*</span>
        <input type="text"
               [ngModel]="newFolderName"
               (ngModelChange)="onNewFolderNameChange($event)"
               [disabled]="newFolderBusy"
               placeholder="e.g. EACC1_13"
               autofocus
               style="font-size:13px;padding:8px 10px;border:1px solid #d1d5db;border-radius:6px;font-weight:400;" />
      </label>

      <label style="display:flex;flex-direction:column;gap:5px;font-size:12.5px;color:#374151;font-weight:500;">
        Title <span style="color:#dc2626;">*</span>
        <input type="text"
               [ngModel]="newFolderTitle"
               (ngModelChange)="onNewFolderTitleChange($event)"
               [disabled]="newFolderBusy"
               placeholder="Shown in the Title column"
               style="font-size:13px;padding:8px 10px;border:1px solid #d1d5db;border-radius:6px;font-weight:400;" />
      </label>

      <label style="display:flex;flex-direction:column;gap:5px;font-size:12.5px;color:#374151;font-weight:500;">
        Description
        <textarea rows="3"
                  [(ngModel)]="newFolderDescription"
                  [disabled]="newFolderBusy"
                  placeholder="Optional — what this folder holds"
                  style="font-size:13px;padding:8px 10px;border:1px solid #d1d5db;border-radius:6px;font-weight:400;resize:vertical;"></textarea>
      </label>

      <div *ngIf="newFolderName && newFolderValidation"
           style="font-size:12px;color:#b45309;display:flex;align-items:center;gap:6px;">
        <span class="material-icons" style="font-size:15px;">info</span>{{ newFolderValidation }}
      </div>
      <div *ngIf="newFolderError"
           style="font-size:12px;color:#dc2626;display:flex;align-items:center;gap:6px;">
        <span class="material-icons" style="font-size:15px;">error_outline</span>{{ newFolderError }}
      </div>
    </div>

    <div style="display:flex;justify-content:flex-end;gap:8px;padding:12px 16px;border-top:1px solid #e5e7eb;">
      <button (click)="cancelNewFolder()" [disabled]="newFolderBusy"
              style="font-size:13px;padding:6px 12px;border:1px solid #cbd5e1;background:#fff;border-radius:5px;cursor:pointer;">Cancel</button>
      <button (click)="confirmNewFolder()" [disabled]="!newFolderValid || newFolderBusy"
              [style.opacity]="(!newFolderValid || newFolderBusy) ? 0.55 : 1"
              style="font-size:13px;padding:6px 14px;border:1px solid #2563eb;background:#2563eb;color:#fff;border-radius:5px;cursor:pointer;">
        {{ newFolderBusy ? 'Creating…' : 'Create folder' }}
      </button>
    </div>
  </div>
</div>

<!-- Move-to picker modal -->
<div class="sp-move-overlay" *ngIf="moveOpen"
     style="position:fixed;inset:0;background:rgba(15,23,42,.45);display:flex;align-items:center;justify-content:center;z-index:1000;">
  <div style="background:#fff;border-radius:10px;width:520px;max-width:92vw;max-height:80vh;display:flex;flex-direction:column;box-shadow:0 10px 40px rgba(0,0,0,.25);">
    <div style="display:flex;align-items:center;justify-content:space-between;padding:14px 16px;border-bottom:1px solid #e5e7eb;">
      <span style="font-size:15px;font-weight:600;color:#1f2937;">Move &ldquo;{{ selectedDocument?.name }}&rdquo;</span>
      <button (click)="closeMove()" style="border:none;background:none;cursor:pointer;font-size:18px;color:#6b7280;">&times;</button>
    </div>
    <div style="padding:10px 16px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#475569;display:flex;flex-wrap:wrap;gap:3px;align-items:center;">
      <ng-container *ngFor="let c of moveCrumbs; let i = index">
        <span (click)="moveCrumbTo(i)" style="cursor:pointer;color:#2563eb;">{{ c.name }}</span>
        <span *ngIf="i < moveCrumbs.length - 1" style="color:#9ca3af;">/</span>
      </ng-container>
    </div>
    <div style="flex:1;overflow:auto;padding:6px 10px;min-height:160px;">
      <p *ngIf="moveLoading" style="color:#9ca3af;font-size:13px;text-align:center;padding:16px;">Loading…</p>
      <p *ngIf="!moveLoading && !moveItems.length" style="color:#9ca3af;font-size:13px;text-align:center;padding:16px;">No sub-folders here.</p>
      <div *ngFor="let f of moveItems"
           style="display:flex;align-items:center;justify-content:space-between;padding:7px 8px;border-radius:6px;">
        <span (click)="moveEnter(f)" style="display:flex;align-items:center;gap:8px;cursor:pointer;font-size:13px;color:#374151;">
          <span class="material-icons" style="font-size:18px;color:#f59e0b;">folder</span>{{ f.name }}
        </span>
        <button (click)="confirmMove(f.id, f.name)" [disabled]="moving"
                style="font-size:12px;padding:4px 10px;border:1px solid #cbd5e1;background:#fff;border-radius:5px;cursor:pointer;">Move here</button>
      </div>
    </div>
    <div style="display:flex;justify-content:space-between;align-items:center;padding:12px 16px;border-top:1px solid #e5e7eb;">
      <span style="font-size:12px;color:#6b7280;">Navigate into the destination, then “Move here”.</span>
      <div style="display:flex;gap:8px;">
        <button (click)="closeMove()" style="font-size:13px;padding:6px 12px;border:1px solid #cbd5e1;background:#fff;border-radius:5px;cursor:pointer;">Cancel</button>
        <button (click)="confirmMove(moveCrumbs[moveCrumbs.length-1].id, moveCrumbs[moveCrumbs.length-1].name)"
                [disabled]="moving || moveCrumbs.length <= 1"
                style="font-size:13px;padding:6px 14px;border:1px solid #2563eb;background:#2563eb;color:#fff;border-radius:5px;cursor:pointer;">
          {{ moving ? 'Moving…' : 'Move to this folder' }}
        </button>
      </div>
    </div>
  </div>
</div>